
















import '@/class-component-hooks';
import { Component, Vue, Watch } from 'vue-property-decorator';
import Login from '@/components/Login.vue';
import { Getter } from 'vuex-class';
import User from '@/models/User';
import { EventBus } from '@/event-bus';
import EmployeeHome from '@/views/employee/EmployeeHome.vue';
import EmployerHome from '@/views/employer/EmployerHome.vue';

@Component({
  components: { EmployeeHome, EmployerHome }
})
export default class Home extends Vue {
  dialog = false;
  showDialog = false;
  dialogLabel = '';
  @Getter
  currentUser: User;

  // @Watch('currentUser')
  // onCurrentUserChanged(val: User, oldVal: User) {
  //   this.navigate(val);
  // }

  // navigate(val) {
  //   if (val && val.isEmployer) {
  //     // an employer
  //     this.$router.replace('employerHome');
  //   } else if (val && val.isEmployee) {
  //     // an employee
  //     this.$router.replace('employeeHome');
  //   } else if (val) {
  //     // logged in but not an employer / employee
  //     this.$router.replace('loginas');
  //   } else {
  //     // no current user, thus need to login first
  //     this.$router.replace('login');
  //   }
  // }

  mounted() {
    EventBus.$on('loading', e => {
      this.dialogLabel = e;
      this.showDialog = true;
    });
    EventBus.$on('loaded', () => {
      this.showDialog = false;
    });
  }

  // beforeRouteEnter(to, from, next) {
  //   console.log('beforeRouteEnter');
  //   console.log(this.currentUser);
  //   next(); // needs to be called to confirm the navigation
  // }
}
